module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-4-26e973d061ac4d8b12cfee5c724ed4ec.png";